import { useLocation, Link } from 'react-router-dom';

const ThankYouPage = () => {
  const { state } = useLocation();
  const { nombre, correoElectronico, direccion, telefono, instrucciones } = state || {};

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="card shadow-sm border-0 rounded-4 p-5 text-center" style={{ maxWidth: "600px", width: "100%" }}>
        {/* Icono check ✅ */}
        <div className="mb-4">
          <div className="rounded-circle bg-success d-inline-flex justify-content-center align-items-center" style={{ width: "80px", height: "80px" }}>
            <i className="bi bi-check2 text-white" style={{ fontSize: "2rem" }}></i>
          </div>
        </div>

        {/* Mensaje principal */}
        <h2 className="fw-bold text-success mb-2">¡Gracias por tu pedido!</h2>
        <p className="lead text-muted mb-4">Pronto nos pondremos en contacto para confirmar la entrega.</p>

        {/* Resumen */}
        <div className="text-start bg-white border rounded-3 p-3 shadow-sm mx-auto" style={{ maxWidth: "450px" }}>
          <h5 className="fw-semibold mb-3">📦 Resumen de entrega</h5>
          <p className="mb-1"><strong>Nombre:</strong> {nombre}</p>
          <p className="mb-1"><strong>Correo:</strong> {correoElectronico}</p>
          <p className="mb-1"><strong>Dirección:</strong> {direccion}</p>
          <p className="mb-1"><strong>Teléfono:</strong> {telefono}</p>
          <p className="mb-0"><strong>Instrucciones:</strong> {instrucciones}</p>
        </div>

        {/* Botón volver */}
        <Link 
          to="/" 
          className="btn btn-primary btn-lg rounded-pill shadow-sm mt-4 px-4"
        >
          🏠 Volver al inicio
        </Link>
      </div>
    </div>
  );
};

export default ThankYouPage;
